import React, { useState } from 'react';
import { useRouter } from 'next/router';

import { useTranslation } from '../../hooks/translation';
import { useHttp } from '../../hooks/network';
import AppBlogCard from '../AppBlogCard/AppBlogCard';
import AppButton from '../AppButton/AppButton';
import AppContainer from '../AppContainer/AppContainer';

import styles from './AppBlog.module.scss';

export default function AppBlog({ blogs, moreLink }) {

  const { locale } = useRouter();

  const { translate } = useTranslation();

  const [nextLink, setNextLink] = useState(moreLink);
  const [blogsList, setBlogsList] = useState(blogs);
  const [loading, setLoading] = useState(false);

  const fetchMoreBlogs = async () => {
    setLoading(true);
    // eslint-disable-next-line
    const { request } = useHttp({ locale });
    const { data } = await request({
      url: nextLink,
      params: {},
    });
    setBlogsList((prevState) => {
      return [...prevState, ...data.data];
    });
    setNextLink(data.links.next);
    setLoading(false);
  };

  const fetchBlogs = () => {
    // eslint-disable-next-line
    fetchMoreBlogs();
  };

  return (
    <div className={styles.AppBlog}>
      <AppContainer>
        <div className={styles.AppBlog_Inner}>
          {blogsList?.map((item, i) => (
            <AppBlogCard key={i} blog={item} />
          ))}
        </div>
        <div className={styles.AppBlog_More}>
          {nextLink && (
            <AppButton round onClick={fetchBlogs}>
              {loading ? `${translate('loading')}` : `${translate('load_more')}`}
            </AppButton>
          )}
        </div>
      </AppContainer>
    </div>
  );
}
